import { useTranslation } from 'react-i18next';

import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

import { GET_CURRENT_ACCOUNT } from 'src/hooks/accounts/get-current-account.hook';

const UPDATE_CURRENT_PROFILE = gql`
  mutation updateCurrentProfile($payload: UpdateCurrentProfileInput!) {
    updateCurrentProfile(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateCurrentProfile = () => {
  const { t } = useTranslation(['settings']);
  const [updateCurrentProfile] = useMutation(UPDATE_CURRENT_PROFILE, {
    refetchQueries: [GET_CURRENT_ACCOUNT],
    onCompleted: () =>
      showNotification({
        type: NOTIFICATION_TYPE.success,
        message: t('settings:userProfileSettings.success.profileChanges.title'),
      }),
  });

  return updateCurrentProfile;
};
